export default {
    name: "ArticleAuthor",
    props: {
        author: {
            type: String,
            default: ""
        }
    },
    computed: {
        byline() {
            const authorKey = this.author.replace(/\s|-/gm, "_");
            return this.$t(authorKey);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/ArticleAuthor/ArticleAuthor.js